import React, { useEffect, useState } from 'react';


function DatabasePage() {
  const [tables, setTables] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedTable, setSelectedTable] = useState(null);
  const [tableData, setTableData] = useState(null);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableError, setTableError] = useState(null);
  const [rawTableResponse, setRawTableResponse] = useState(null);

  useEffect(() => {
    fetch('/api/admin/list-tables')
      .then(res => res.json())
      .then(data => {
        if (data.tables) setTables(data.tables);
        else setError(data.error || 'Unknown error');
        setLoading(false);
      })
      .catch(() => {
        setError('Network error');
        setLoading(false);
      });
  }, []);

  const handleTableClick = (table) => {
    setSelectedTable(table);
    setTableData(null);
    setTableError(null);
    setRawTableResponse(null);
    setTableLoading(true);
    fetch(`/api/admin/table/${encodeURIComponent(table)}`)
      .then(res => res.json())
      .then(data => {
        setRawTableResponse(data);
        if (data.rows) setTableData(data.rows);
        else setTableError(data.error || 'Unknown error');
        setTableLoading(false);
      })
      .catch((err) => {
        setTableError('Network error');
        setTableLoading(false);
      });
  };

  return (
    <div>
      <h2 style={{ fontWeight: 'bold', marginBottom: 16 }}>Database Management</h2>
      <p style={{ color: '#555' }}>
        Below is a list of all tables in the database:
      </p>
      {loading ? (
        <div>Loading tables...</div>
      ) : error ? (
        <div style={{ color: '#d32f2f' }}>{error}</div>
      ) : (
        <ul style={{ marginTop: 16, fontSize: '1.05rem' }}>
          {tables.map((t) => (
            <li key={t} style={{ marginBottom: 6 }}>
              <button
                style={{
                  background: selectedTable === t ? '#e3e3e3' : 'white',
                  border: '1px solid #bbb',
                  borderRadius: 4,
                  padding: '4px 12px',
                  cursor: 'pointer',
                  fontWeight: selectedTable === t ? 'bold' : 'normal',
                }}
                onClick={() => handleTableClick(t)}
              >
                {t}
              </button>
            </li>
          ))}
        </ul>
      )}

      {selectedTable && (
        <div style={{ marginTop: 32 }}>
          <h3 style={{ fontWeight: 'bold' }}>Table: {selectedTable}</h3>
          {tableLoading ? (
            <div>Loading table data...</div>
          ) : tableError ? (
            <div style={{ color: '#d32f2f' }}>{tableError}</div>
          ) : tableData && tableData.length > 0 ? (
            <div style={{ overflowX: 'scroll', marginTop: 12, width: '100%' }}>
              <table style={{ borderCollapse: 'collapse', minWidth: 900, width: '100%' }}>
                <thead>
                  <tr>
                    {Object.keys(tableData[0]).map((col) => (
                      <th key={col} style={{ border: '1px solid #bbb', padding: '4px 8px', background: '#f5f5f5' }}>{col}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((row, idx) => (
                    <tr key={idx}>
                      {Object.entries(row).map(([col, val], i) => (
                        <td key={i} style={{ border: '1px solid #ddd', padding: '4px 8px' }}>
                          {col.toLowerCase() === 'amount' && !isNaN(val) && val !== ''
                            ? Number(val).toFixed(2)
                            : String(val)}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : tableData && tableData.length === 0 ? (
            <div style={{ color: '#888', marginTop: 8 }}>No rows in this table.</div>
          ) : null}
          {/* Debug: Show raw response if error or no data */}
          {(tableError || (tableData && tableData.length === 0)) && rawTableResponse && (
            <pre style={{ background: '#f9f9f9', color: '#333', fontSize: 13, marginTop: 16, padding: 8, borderRadius: 4, border: '1px solid #eee' }}>
              Raw response: {JSON.stringify(rawTableResponse, null, 2)}
            </pre>
          )}
        </div>
      )}
    </div>
  );
}

export default DatabasePage;